import { useId } from 'react';

interface Props {
  size: number;
  color: string;
}

/**
 * Génére une grille carrée de coté {size} qui peut ensuite être affichée
 * par dessus un QR code de taille similaire. Les yeux ne sont pas couvert.
 */
const Overlay = ({ size, color }: Props) => {
  const id = useId();
  const maskId = `${id}-mask`;
  const fillId = `${id}-fill`;

  return (
    <svg viewBox={`0 0 ${size} ${size}`}>
      <pattern id={fillId} width="1" height="1" patternUnits="userSpaceOnUse">
        <rect width="1" height="1" strokeWidth="0.1" stroke={color} fill="transparent" />
      </pattern>
      <mask id={maskId}>
        <rect fill="#fff" width={size} height={size} />
        <rect fill="#000" width="7" height="7" />
        <rect fill="#000" y={size - 7} width="7" height="7" />
        <rect fill="#000" x={size - 7} y={0} width="7" height="7" />
      </mask>
      <rect width={size} height={size} mask={`url(#${maskId})`} fill={`url(#${fillId})`} />
    </svg>
  );
};

export default Overlay;
